<p-dialog
  header="Alocação no Millennium"
  [modal]="true"
  [visible]="visible"
  [closable]="true"
  [resizable]="false"
  [draggable]="false"
  [style]="dialogStyle"
  (visibleChange)="close()"
  (onHide)="close()"
>
  <p>{{ foundNotice }}</p>
  <p *ngIf="detailMessage">{{ detailMessage }}</p>
  <dl class="millennium-allocation">
    <ng-container *ngFor="let row of rows">
      <dt>{{ row.label }}</dt>
      <dd>{{ row.value }}</dd>
    </ng-container>
  </dl>
  <div class="dialog-buttons">
    <p-button label="Fechar" severity="secondary" (onClick)="close()" />
  </div>
</p-dialog>
